var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-containre"},[_c('img',{staticClass:"back",attrs:{"src":require("@/assets/images/back.png"),"alt":""},on:{"click":function($event){return _vm.goBack()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }